import { render, staticRenderFns } from "./VerificationSuccess.vue?vue&type=template&id=f4388aea&scoped=true"
import script from "./VerificationSuccess.vue?vue&type=script&lang=js"
export * from "./VerificationSuccess.vue?vue&type=script&lang=js"
import style0 from "./VerificationSuccess.vue?vue&type=style&index=0&id=f4388aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4388aea",
  null
  
)

export default component.exports